<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Push Notifications</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Push Notifications
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="newNotificationModal" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    New Notification
                </button>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Push Notifications</h4>
                </div>

                <div class="card-body">
                    <div class="search-container">
                        <div class="row">
                            <div class="col-lg-9 col-md-8 col-sm-6 d-flex align-items-center">
                                <img src="/images/search.svg" alt="">

                            </div>
                        </div>

                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allPushNotifications"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'action'">
                               <span class="dropdown">
									<a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                        class="fa fa-ellipsis-v"></i></a>
                                    <span aria-labelledby="btnSearchDrop2"
                                          class="dropdown-menu mt-1 dropdown-menu-right"
                                          x-placement="bottom-end"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                          x-out-of-boundaries="">
                                        <a @click.prevent="sendNotification(props.row.id)" class="dropdown-item edit">
                                            <i class="feather icon-arrow-right-circle"></i> Send Notification
                                        </a>

<!--                                        <div class="dropdown-divider"></div>-->
                                        <!--                                        <a href="#" class="dropdown-item text-danger delete"><i-->
                                        <!--                                            class="feather icon-trash-2"></i> Delete</a>-->

                                    </span>
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade new-notification-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="addNewNotification">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">Send New Notification</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Group</label>
                                <select v-model="notification.group" id="" class="form-control" required>
                                    <option value="" selected>Select a user group</option>
                                    <option value="users" selected>Users</option>
                                    <option value="drivers" selected>Driver</option>
                                    <option value="fleet_managers" selected>Fleet Managers</option>
                                </select>
                                <div v-if="notification.errors.group" class="text-danger text-small">
                                    {{ notification.errors.group }}
                                </div>
                            </div>
                            <div class="form-group"><label>Notification Title</label>
                                <input type="text" required="required"
                                       class="form-control" v-model="notification.title">
                                <div v-if="notification.errors.title" class="text-danger text-small">
                                    {{ notification.errors.title }}
                                </div>
                            </div>
                            <div class="form-group"><label>Notification Message</label>
                                <textarea class="form-control" name="" id="" cols="30" rows="5"
                                          v-model="notification.body"></textarea>
                                <div v-if="notification.errors.body" class="text-danger text-small">
                                    {{ notification.errors.body }}
                                </div>
                            </div>

                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Push Notifications'},
    name: 'PushNotificationIndex',
    props: ['pushNotifications'],
    layout: Layout,

    data() {
        return {
            allPushNotifications: [],
            notification: this.$inertia.form({
                title: null,
                group: null,
                body: null
            }),
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },
            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },
            columns: [
                {label: 'S/N', field: 'sn'},
                {label: 'Title', field: 'title', width: '10%'},
                {label: 'Body', field: 'body', width: '30%'},
                {label: 'Group', field: 'group', width: '30%'},
                {label: 'Added by', field: 'added_by'},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
            saving: false,
        }
    },
    mounted() {
        this.allPushNotifications = this.pushNotifications.data;
        this.totalRecords = this.pushNotifications.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            // todo: make this work , change the route and response data
            try {
                const type = this.type;
                let routeName = 'cms.blogs.paginate';
                if (type === 'research') {
                    routeName = 'cms.research-insight.paginate';
                }

                let {data: {data: {posts}}} = await axios.post(route(routeName),
                    {...this.serverParams});

                this.totalRecords = posts.total;
                this.paginationOptions.perPage = posts.per_page;
                this.post = posts.data
            } catch (e) {
                console.log(e);
            }
        },

        async addNewNotification() {
            this.saving = true;
            this.notification.post(route('admin.notifications.push.store'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.allPushNotifications = this.pushNotifications.data;
                    $('.new-notification-modal').modal('hide');
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            })
        },

        async sendNotification(id) {
            this.saving = true;
            this.notification.post(route('admin.notifications.push.send', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            })
        },

        newNotificationModal() {
            $('.new-notification-modal').modal('show');
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
        showAlert(roleId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure you want to delete this roles?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteRole(roleId)
                }
            });
        },
    }
}
</script>
